<template>
    <div>
        <template v-for="(route) in routes">
            <template v-if="showPage(route)">
                <MenuSpacer v-if="route.meta.spacerBefore" v-bind:key="route.name + '_spacer'"></MenuSpacer>
                <MenuItem v-bind:key="route.name + '_item'"
                          :label="route.name"
                          :icon="route.meta.icon"
                          :selected="isSelected(route)"
                          v-on:click.native="navigate(route)">
                </MenuItem>
                <MenuSpacer v-if="route.meta.spacerNext" v-bind:key="route.name + '_spacer'"></MenuSpacer>
            </template>
        </template>
    </div>
</template>

<script>
  import MenuItem from '@/components/sidenav/MenuItem.vue'
  import MenuSpacer from '@/components/sidenav/MenuSpacer.vue'
  import Routes from '@/constants/routes'
  import hasPermission from "../../filters/hasPermission";

  export default {
    name: 'Menu',
    components: {
      MenuItem,
      MenuSpacer
    },
    data() {
      return {
        routes: Routes
      }
    },
    methods: {
      showPage(route) {
        return route.meta.rootPage && hasPermission(route.meta.allowedRoles);
      },
      navigate(route) {
        if (!this.isSelected(route)) {
          this.$router.push(route.path);
        }
      },
      isSelected(route) {
        return this.haveSameTitle(this.$route, route) || (route.children && route.children.some(child => this.haveSameTitle(child, this.$route)) && this.$route.fullPath.includes(route.path));
      },
      haveSameTitle(routeA, routeB) {
        const titleA = routeA.meta.title;
        const titleB = routeB.meta.title;
        if (titleA && titleB) {
          return routeA.meta.title === routeB.meta.title
        }
        if (titleA && !titleB || !titleA && titleB) {
          return false;
        }
        return routeA.name === routeB.name;
      }
    },
  }
</script>
